import { render } from "./OrderDay.vue?vue&type=template&id=fdbc11cc"
import script from "./OrderDay.vue?vue&type=script&lang=js"
export * from "./OrderDay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__